<template>
  <div class="flex items-center justify-center h-screen px-6 bg-gray-200">
    <div class="w-full max-w-sm p-6 bg-white rounded-md shadow-md">
      <div class="flex items-center justify-center">
        <span class="text-2xl font-semibold text-gray-700">
          {{ $lang.app.LOGIN_AS_EMPLOYEE }}
        </span>
      </div>
      <Form class="mt-4" @submit="login" :validation-schema="schema">
        <label class="block">
          <span class="text-sm text-gray-700">{{ $lang.app.LOGIN }}</span>
          <Field
            name="login"
            type="email"
            class="block w-full mt-1 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
          />
          <ErrorMessage name="login" class="text-xs text-red-400" />
        </label>

        <label class="block mt-3">
          <span class="text-sm text-gray-700">{{ $lang.app.PASSWORD }}</span>
          <Field
            name="password"
            type="password"
            class="block w-full mt-1 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
          />
          <ErrorMessage name="password" class="text-xs text-red-400" />
        </label>
        <div class="mt-6">
          <button
            type="submit"
            class="w-full px-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500"
          >
            {{ $lang.app.SIGN_IN }}
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import { Field, Form, ErrorMessage } from "vee-validate";
import * as yup from "yup";
export default {
  name: "EmployeeLogin",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      schema: yup.object({
        login: yup.string().required(),
        password: yup.string().required(),
      }),
    };
  },
  methods: {
    login(values, actions) {
      this.$store
        .dispatch("loginEmployee", values)
        .then(() => {
          if(this.$store.getters.getAttemptUrl) {
            this.$router.push(this.$store.getters.getAttemptUrl)
            this.$store.commit('setAttemptUrl', null)
          } else {
            if(this.$store.getters.isAdmin) {
              return this.$router.push({name: 'Admin'})
            } else {
              return this.$router.push({name: 'EmployeeApplicationsList'})
            }
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            actions.setErrors(err.response.data.errors);
          }
        });
    },
  },
};
</script>
